import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import Home from "@/pages/Home";
import { ChatWidget } from "@/components/ChatWidget";
import TrackingResult from "@/pages/TrackingResult";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Settings from "@/pages/Settings";
import BatchLabels from "@/pages/BatchLabels";
import PhoneResults from "@/pages/PhoneResults";
import NewShipment from "@/pages/NewShipment";
import ShipmentDetail from "@/pages/ShipmentDetail";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="p-16 text-center text-slate-500" data-testid="auth-checking">Vérification…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

const Footer = () => (
  <footer className="border-t border-slate-200 bg-white">
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-8">
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
        Haba Trans Logistique — Fret Canada · Côte d'Ivoire
      </p>
      <p className="mt-2 text-sm text-slate-500">© {new Date().getFullYear()} Haba Trans Logistique.</p>
    </div>
  </footer>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="flex min-h-screen flex-col bg-[#F8FAFC] font-body text-slate-800">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<><Home /><ChatWidget /></>} />
              <Route path="/suivi/:trackingNumber" element={<><TrackingResult /><ChatWidget /></>} />
              <Route path="/suivi-telephone" element={<><PhoneResults /><ChatWidget /></>} />
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
              <Route path="/admin/parametres" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/admin/etiquettes" element={<ProtectedRoute><BatchLabels /></ProtectedRoute>} />
              <Route path="/admin/nouvelle-livraison" element={<ProtectedRoute><NewShipment /></ProtectedRoute>} />
              <Route path="/admin/livraison/:id" element={<ProtectedRoute><ShipmentDetail /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
